import { getRequest } from '../services/requestHandler';
import { HeadWeightLocationAftDto } from '../models';

export const getHeadWeightLocationAft = async () => {
  const url = 'HeadWeight/GetHeadWeightLocationsAft';
  const response = await getRequest<HeadWeightLocationAftDto>('GetHeadWeightLocationsAft', url);
  // TODO: Remove this from here and implement uuid when API is available
  let autoId = 0;
  let locations = response.map((r) => {
    return { ...r, headWeightLocationAftId: autoId++ };
  });
  return locations;
};
